export enum MessageType {
  PLAYER_JOIN = 0x01,
  PLAYER_LEAVE = 0x02,
  PLAYER_MOVE = 0x03,
  BLOCK_PLACE = 0x04,
  BLOCK_BREAK = 0x05,
  CHAT_MESSAGE = 0x06,
  CHUNK_DATA = 0x07,
  SERVER_INFO = 0x08,
  PING = 0x09,
  PONG = 0x0a,
  CHUNK_REQUEST = 0x0b,
  PLAYER_LIST = 0x0c,
}

export interface PlayerJoinMessage {
  type: MessageType.PLAYER_JOIN;
  playerId: number;
  name: string;
  skinId: number;
  x: number;
  y: number;
  z: number;
}

export interface PlayerMoveMessage {
  type: MessageType.PLAYER_MOVE;
  playerId: number;
  x: number;
  y: number;
  z: number;
  yaw: number;
  pitch: number;
}

export interface BlockPlaceMessage {
  type: MessageType.BLOCK_PLACE;
  x: number;
  y: number;
  z: number;
  blockId: number;
}

export interface BlockBreakMessage {
  type: MessageType.BLOCK_BREAK;
  x: number;
  y: number;
  z: number;
}

export interface ChatMessageData {
  type: MessageType.CHAT_MESSAGE;
  playerId: number;
  text: string;
}

export interface ServerInfoMessage {
  type: MessageType.SERVER_INFO;
  serverName: string;
  playerCount: number;
  maxPlayers: number;
  motd: string;
}

export type GameMessage =
  | PlayerJoinMessage
  | PlayerMoveMessage
  | BlockPlaceMessage
  | BlockBreakMessage
  | ChatMessageData
  | ServerInfoMessage;
